// react-redux imports
import { MouseEvent, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "app/store";
import { ResidenceOptions, setResidenceType } from "./residenceSlice";

// common imports
import StyledSectionTitle from "common/components/styled-components/SectionTitle";
import FlexSpan from "common/components/styled-components/FlexSpan";
import ImageButtonContainer from "common/components/styled-components/ImageButtonContainer";
import ImageButton from "common/components/ImageButton";
import PopUpParagraph from "common/components/styled-components/PopUpParagraph";
import Tooltip from "common/components/Tooltip";
import TooltipPopUp from "common/components/TooltipPopUp";
import residenceTypeFlat from "common/img/residence-type-flat.jpg";
import residenceTypeHouse from "common/img/residence-type-house.jpg";
import { TooltipAction, TOOLTIP_ACTIONS } from "common/constants/tooltip";

interface StepOneProps {
  buttonSize?: number;
}

function StepOne({ buttonSize }: StepOneProps) {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const dispatch = useDispatch();
  const residenceType = useSelector(
    (state: RootState) => state.calculator.residence.residenceType
  );

  function handleResidenceTypeSelection(e: MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    const value = e.currentTarget.value as ResidenceOptions;
    if (value === residenceType) dispatch(setResidenceType(null));
    else dispatch(setResidenceType(value));
  }

  function handleTooltip(action: TooltipAction) {
    switch (action) {
      case "open":
        return () => setIsTooltipOpen(true);

      case "close":
        return () => setIsTooltipOpen(false);

      case "toggle":
        return () => setIsTooltipOpen(!isTooltipOpen);

      default:
        return () => undefined;
    }
  }

  return (
    <>
      <StyledSectionTitle>
        <span>
          ¿Cuál es tu tipo de{" "}
          <FlexSpan>
            vivienda?&nbsp;
            <Tooltip onClick={handleTooltip(TOOLTIP_ACTIONS.TOGGLE)} />
          </FlexSpan>
        </span>
        {isTooltipOpen && (
          <TooltipPopUp
            title="¿Cuál es tu tipo de vivienda?"
            handleClose={handleTooltip(TOOLTIP_ACTIONS.CLOSE)}
          >
            <PopUpParagraph>
              Tu huella de carbono será calculada de manera individual. En el
              caso de que conviváis más de una persona en casa intriduce los
              datos globales y al final se dividirá el resultado entre las
              personas que compartís vivienda
            </PopUpParagraph>
          </TooltipPopUp>
        )}
      </StyledSectionTitle>
      <ImageButtonContainer>
        <ImageButton
          value="house"
          label="Unifamiliar"
          selected={residenceType === "house"}
          url={residenceTypeHouse}
          onClick={handleResidenceTypeSelection}
          size={buttonSize}
        />
        <ImageButton
          value="flat"
          label="Piso"
          selected={residenceType === "flat"}
          url={residenceTypeFlat}
          onClick={handleResidenceTypeSelection}
          size={buttonSize}
        />
      </ImageButtonContainer>
    </>
  );
}

export default StepOne;
